import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: 1em 0;

	.job-result {
		&:not(:last-child) {
			margin-bottom: 2em;
		}
		&.visited {
			.content {
				.job-results-txt {
					.job-results-position {
						.job-results-name {
							color: #714fa8;
						}
					}
				}
			}
		}
	}

	.collection-zero-state {

		padding: 2em;

		.zero-state-title {
			text-align: center;
			font-size: 1em;
			margin-left: auto;
			margin-right: auto;
		}

		.zero-state-subtitle {
			text-align: center;
			font-size: 1em;
			margin-top: 1em;

		}

		.zero-state-clear-filters-button,
		.zero-state-save-button {
			margin-top: 2em;
		}

		.zero-state-clear-filters-button + .zero-state-save-button {
			margin-top: 1em;
		}
	}

	@media all and (max-width: ${vars.tabletL}) {

		.collection-zero-state {
			.zero-state-title {
				font-size: 1.2em;
			}

			.zero-state-subtitle {
				font-size: 1.2em;

			}
		}

	}

	@media all and (max-width: ${vars.mobileM}) {

		.collection-zero-state {
			.zero-state-title {
				font-size: 1.2em;
			}

			.zero-state-subtitle {
				font-size: 1.2em;

			}
		}

	}
`;
